import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { format } from 'date-fns';
import fr from 'date-fns/locale/fr';
import TransportEvent from '../TransportEvent';
import styles from './outgoing-shared-transports.module.scss';

function getSortDate(event) {
  if (event.startDate) return new Date(event.startDate);
  if (event.deliveryDate) return new Date(event.deliveryDate);
  return new Date(0);
}

const OutgoingSharedTransports = ({ events = [] }) => {
  if (!events.length) return null;

  const sorted = [...events].sort((a, b) => getSortDate(a) - getSortDate(b));

  return (
    <div className={styles.outgoingSharedSection}>
      <p className={styles.outgoingSharedTitle}>
        Transports partagés (
        {sorted.length}
        )
      </p>
      <Droppable droppableId="outgoingShared" isDropDisabled>
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={styles.outgoingSharedList}
          >
            {sorted.map((event, index) => (
              <div key={event._id} className={styles.outgoingSharedCard}>
                {event.startDate && (
                  <p className={styles.outgoingSharedMeta}>
                    {format(new Date(event.startDate), 'EEE d MMM · HH:mm', { locale: fr })}
                  </p>
                )}
                <TransportEvent
                  index={index}
                  id={event._id}
                  number={event.number}
                  agency={event.agency}
                  sharedAgency={event.sharedAgency}
                  startDate={event.startDate}
                  endDate={event.endDate}
                  loadDate={event.loadDate}
                  loadDateEnd={event.loadDateEnd}
                  deliveryDate={event.deliveryDate}
                  deliveryDateEnd={event.deliveryDateEnd}
                  deliveryLocationCity={event?.deliveryLocation?.city}
                  loadLocationCity={event?.loadLocation?.city}
                  clients={event?.cases}
                  type={event.type}
                  transport={event.transport}
                  showTransport={false}
                  view="week"
                  trunkType={event.trunkType}
                  carrier={event.carrier}
                  direction={event.direction}
                  linkedTasks={event.linkedTasks}
                  steps={(event.steps || []).filter((step) => step.type === event.direction)}
                  countGroup={1}
                  zIndex={index}
                  indexInGroup={0}
                  hasWarning={event.hasWarning}
                  showComments={false}
                  showIconComments={!!event.commentIntern}
                  commentIntern={event.commentIntern}
                  commentExtern={event.commentExtern}
                  maxWidth={100}
                  notAssign={!event.startDate}
                  isDragDisabled
                />
              </div>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
};

export default OutgoingSharedTransports;
